import { render, staticRenderFns } from "./text_component.vue?vue&type=template&id=202ad168&scoped=true&"
import script from "./text_component.vue?vue&type=script&lang=js&"
export * from "./text_component.vue?vue&type=script&lang=js&"
import style0 from "./text_component.vue?vue&type=style&index=0&id=202ad168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202ad168",
  null
  
)

export default component.exports